import { call, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';
import { actionTypes, requestSuccess, requestFailure } from './actions';
import getSiteMap from '../../services/API/getSiteMap';

function* getSiteMapSaga() {
  const response = yield call(getSiteMap);
  if (response.isOk) {
    return yield put(requestSuccess(get(response, 'data')));
  }
  return yield put(requestFailure(get(response, 'error')));
}

export default function* siteMapSaga() {
  yield takeLatest(actionTypes.START_REQUEST, getSiteMapSaga);
}
